<template>
  <div class="s-modal__wrapper s-modal__wrapper--blue">
    <!-- Header -->
    <div class="s-modal__header s-modal__header--blue">
      <p class="s-modal__label--hint">HINT</p>
      <button id="s-modal-close"
              type="button" class="s-modal__btn--close s-modal__btn--close--white s-modal__btn--close--sm" data-dismiss="modal" aria-label="Close"
              @click="$emit('closePopup')"></button>
    </div>

    <!-- Main Content -->
    <div class="s-modal__body s-modal__body--hint">
      <button :class="nowIndex !== 0 ? 'on' : 'off'"
              @click="nowIndex--"
              class="s-modal__btn--nav s-modal__btn--nav__left"></button>
      <button :class="nowIndex !== (data.length - 1) ? 'on' : 'off'"
              @click="nowIndex++"
              class="s-modal__btn--nav s-modal__btn--nav__right"></button>
      <!-- Thumb -->
      <div class="s-modal__wrapper--thumb">
        <div class="s-modal-content--thumb">
          <img :src="data.length ? data[nowIndex].hintImage : ''">
        </div>
      </div>
      <!-- Text Hint -->
      <div class="s-modal__wrapper--hint">
        <div id="hint-body" class="s-modal-content--hint">
          <p v-html="data.length ? data[nowIndex].desText : ''"></p>
        </div>
        <div class="s-modal-content--hint--image" :class="{ peng: type === 'runner', jb: isJb }"></div>
      </div>
      <!-- Nav -->
      <div class="s-modal-content--hint--nav">
            <span v-for="(hint, hi) in data"
                  class="s-modal__btn--nav--point"
                  :class="hi === nowIndex ? 'active' : ''"></span>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: 'modalHintTemplate',
      props : {
        data: {
          type: Array,
          default: () => []
        },
        type: {},
        isJb: {}
      },
      data() {
        return {
          nowIndex: 0
        }
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/stage/modal/ModalPartialHint.vue